export default __webpack_public_path__ + "static/media/5.ab72d89f.png";